module.exports = __webpack_public_path__ + "static/media/hero-4.1ea7d52c.jpg";